module.exports = new __parcel__URL__("joined.a7a4ca91.mp3").toString();